<div class="modal-header">
  <h4 class="modal-title pull-left">
    Reset Password
    <span class="sb-title">
      Users who are new to this system must reset their password
      <br />Enter your email and we will send you a link to get back into your
      account</span
    >
  </h4>
  <button
    type="button"
    class="close pull-right circle-icon circle-icon2"
    aria-label="Close"
    role="button"
    (click)="hideAndReset()"
  >
    <img src="../assets/images/cross.svg" />
  </button>
</div>
<div class="modal-body">
  <span class="pass-note m-0 text-danger" *ngIf="error != ''">{{ error }}</span>
  <form [formGroup]="forgotForm">
    <div class="form-group mb-4 no-float-fields">
      <label class="form-label">Email *</label>
      <mat-form-field appearance="outline">
        <input
          matInput
          type="text"
          formControlName="email"
          placeholder="Enter email"
        />
      </mat-form-field>
      <p
        class="pass-note m-0 text-danger"
        *ngIf="
          forgotForm.get('email').hasError('required') &&
          (forgotForm.get('email').dirty || forgotForm.get('email').touched)
        "
      >
        Email is required
      </p>
      <p
        class="pass-note m-0 text-danger"
        *ngIf="
          forgotForm.get('email').hasError('pattern') &&
          (forgotForm.get('email').dirty || forgotForm.get('email').touched)
        "
      >
        Invalid email
      </p>
    </div>
  </form>
  <button
    type="button"
    class="btn btn-colored btn-login mt-2"
    role="button"
    (click)="onForgotSubmit()"
    [disabled]="loading || forgotForm.invalid"
  >
    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span
    >Reset My Password
  </button>

  <div class="no-account">
    Remember Your Password ?
    <a
      href="javascript:void(0)"
      role="button"
      (click)="modalRef.hide(); openModalFile('login')"
      >Login</a
    >
  </div>
</div>
